(() => {
  /** @param {HTMLElement} panel */
  function bindGallery(panel) {
    const gallery = panel.querySelector('[data-option-gallery]');
    const track = /** @type {HTMLElement | null} */ (gallery ? gallery.querySelector('[data-gallery-track]') : null);
    const prev = gallery ? gallery.querySelector('[data-gallery-prev]') : null;
    const next = gallery ? gallery.querySelector('[data-gallery-next]') : null;
    const dots = /** @type {HTMLElement[]} */ (gallery ? Array.from(gallery.querySelectorAll('[data-gallery-dot]')) : []);
    const slides = /** @type {HTMLElement[]} */ (track ? Array.from(track.children) : []);
    const legendItems = /** @type {HTMLElement[]} */ (Array.from(panel.querySelectorAll('.madesa-projetos__option-copy li')));

    if (!gallery || !track || !prev || !next || !slides.length) return;

    let index = 0;

    const paint = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
      legendItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    prev.addEventListener('click', () => {
      index = index > 0 ? index - 1 : slides.length - 1;
      paint();
    });

    next.addEventListener('click', () => {
      index = index < slides.length - 1 ? index + 1 : 0;
      paint();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = Number(dot.getAttribute('data-gallery-dot') || '0');
        index = Number.isNaN(target) ? 0 : target;
        paint();
      });
    });

    legendItems.forEach((item, itemIndex) => {
      if (itemIndex >= slides.length) return;

      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-label', `Ir para slide ${itemIndex + 1}`);

      item.addEventListener('click', () => {
        index = itemIndex;
        paint();
      });

      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        index = itemIndex;
        paint();
      });
    });

    const panelWithReset = /** @type {any} */ (panel);
    panelWithReset.__resetGallery = () => {
      index = 0;
      paint();
    };

    paint();
  }

  /** @param {HTMLElement} group */
  function initGroup(group) {
    const buttons = /** @type {HTMLElement[]} */ (Array.from(group.querySelectorAll('[data-option-button]')));
    const panels = /** @type {HTMLElement[]} */ (Array.from(group.querySelectorAll('[data-option-panel]')));
    if (!buttons.length || !panels.length) return;

    panels.forEach(bindGallery);

    /** @param {string} target */
    const activate = (target) => {
      buttons.forEach((button) => {
        const isActive = button.dataset.optionButton === target;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
      });

      panels.forEach((panel) => {
        const isCurrent = panel.dataset.optionPanel === target;
        panel.hidden = !isCurrent;
        const panelWithReset = /** @type {any} */ (panel);
        if (isCurrent && typeof panelWithReset.__resetGallery === 'function') {
          panelWithReset.__resetGallery();
        }
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.optionButton || ''));
    });

    const initial = buttons.find((button) => button.classList.contains('is-active')) || buttons[0] || null;
    if (!initial) return;
    activate(initial.dataset.optionButton || '');
  }

  function init() {
    const groups = /** @type {HTMLElement[]} */ (Array.from(document.querySelectorAll('.madesa-projetos-page-options .madesa-projetos__section--options')));
    groups.forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
